<template>
  <!-- 馆藏精品 -->
  <div class="page-collect-treasure">
    <div class="g-banner white">
      <cmpBanner bannerType="3"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>

    <div class="box box-1">
      <div class="list">
        <div class="item g-pointer" @click="goDetail(data1[0])">
          <h2>{{data1[0].name}}</h2>
          <div class="pic-box">
            <img v-lazy="data1[0].picUrl" alt="">

            <div class="btn-view">
              <i></i>
              <p>点击查看详情</p>
            </div>
          </div>
          <div class="desc five-ell">{{data1[0].desc}}</div>
        </div>

        <div class="item g-pointer" @click="goDetail(data1[1])">
          <div class="pic-box">
            <img v-lazy="data1[1].picUrl" alt="">
          </div>
          <div class="info">
            <h2 class="m-font-4">{{data1[1].name}}</h2>
            <p class="year">{{data1[1].year}}</p>
          </div>
        </div>

        <div class="item g-pointer" @click="goDetail(data1[2])">
          <div class="pic-box">
            <img v-lazy="data1[2].picUrl" alt="">
          </div>
          <div class="info">
            <h2 class="m-font-4">{{data1[2].name}}</h2>
            <p class="year">{{data1[2].year}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="box box-2">
      <!-- <h2>唐人簪花仕女图卷</h2>
      <p class="desc">此图粗绢本，不设背景，以工笔重彩绘仕女五人，女侍一人另有小狗、白鹤及辛夷花点缀其间。</p> -->


      <div class="swiper-container swiper-container-1">
        <div class="swiper-wrapper">
          <div class="swiper-slide g-pointer" v-for="(item, index) in data2" @click="goDetail(item)" :key="index">
            <h2>{{item.name}}</h2>
            <p class="desc">{{item.desc}}</p>
            <div class="pic-box">
              <!-- <img src="~@images/collect_pic_4.png" alt=""> -->
              <img :src="item.picUrl" alt="">

              <div class="btn-view">
                <i></i>
                <p>点击查看详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button-next swiper-button-black"></div>

        <!-- <div class="swiper-pagination swiper-pagination-class"></div> -->
      </div>

      <!-- <div class="pic-box">
        <img src="~@images/collect_pic_4.png" alt="">

        <div class="btn-view">
          <i></i>
          <p>点击查看详情</p>
        </div>
      </div> -->
    </div>

    <div class="box box-3">
      <div class="list">
        <div class="item g-pointer" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="pic-box">
            <img :src="item.picUrl" alt="">
          </div>
          <div class="info">
            <h2 class="two-ell m-font-4">{{item.name}}</h2>
            <p class="year">{{item.year}}</p>
          </div>
        </div>

        <div class="pages" v-show="mapQuery.totalPage && mapQuery.totalPage > 1">
          <div class="pages-r" v-show="mapQuery.totalPage>1">
            <span class="btn btn-prev"
              :class="{'disabled': mapQuery.currentPage==1, 'border': mapQuery.currentPage>1&&mapQuery.currentPage<mapQuery.totalPage}"
              @click="handlePrev()">
              <!-- <i class="el-icon-arrow-left"></i> -->
            </span>
            
            <!-- <div class="pages-count"><span>{{mapQuery.currentPage}}</span> / {{mapQuery.totalPage}}</div> -->

            <span class="btn btn-next" :class="{'disabled': mapQuery.currentPage==mapQuery.totalPage}" @click="handleNext()">
              <!-- <i class="el-icon-arrow-right"></i> -->
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

import cmpTab from '@cmp/tab'
export default {
  components: { cmpTab },
  data() {
    return {
      activeVal: '1',
      tabList: [
        {
          name: '馆藏精品',
          val: '1'
        },
        {
          name: '3D 藏品',
          val: '2'
        },
        {
          name: '数字文物库',
          val: '3'
        },
        // {
        //   name: '文物素材库',
        //   val: '4'
        // }
      ],
      data1: [
        {
          name: '玉猪龙',
          desc: '玉猪龙是红山文化玉器的代表作，这件是已知红山文化玉猪龙中形体较大，形制最规整的一件。白色蛇纹叶岩，肥首大耳，圆睛、吻部前突，口微张，獠牙外露，体蜷曲如环，扁圆厚重，背部有一穿孔。玉猪龙明确出土于墓葬中，而且成对佩戴在墓主人胸前，是社会地位、等级、权力的象征，是按照一定规格制成的原始“礼器”。',
          year: '新石器时代',
          picUrl: require('@images/collect_pic_1.png'),
          id: '21010302862102B0000724'
        },
        {
          name: '西周卷体夔纹蟠龙盖壘',
          desc: '覆盖式盖，上有半浮雕龙纹，通体作蟠龙状，前足蹲踞，爪形足，四趾。盘形口，圆肩，圆腹下收，最大径在肩部，高圈足，通体花纹，两面四分，上下四层，每面上腹饰对向变形卷体夔纹，下腹饰兽面纹，近底及圈足饰夔纹，通体以雷纹衬地。',
          year: '西周',
          picUrl: require('@images/collect_pic_2.png'),
          id: '21010302862105A000206'
        },
        {
          name: '青花开光松竹梅花卉八棱罐',
          desc: '此器物圆唇、直口，高领，斜直肩，鼓腹至底部略收。器物整体造型宏魄，器型硕大，胎体厚重，略有变形。通体施青白釉，釉层滋润，青花发色青中泛紫，淡雅柔和。底足砂底无釉，修足不够规整。整体绘画笔触细腻、线条酣畅流利。 。',
          year: '元代',
          picUrl: require('@images/collect_pic_3.png'),
          id: '21010302862103C001638'
        }
      ],
      data2: [
        {
          name: '簪花仕女图卷',
          desc: '工笔重彩描绘簪花仕女五人，执扇女侍一人，点缀在人物中间有猧儿狗两只，白鹤一只，画左以湖石、辛夷花树一株最後结束。仕女发式都梳作高耸云髻，蓬松博鬓。前额发髻上簪步摇首饰花十一至六树不等，鬟髻之间各簪或牡丹、芍药、荷花、绣球花，花时不同的折枝花一朵。眉间都贴金花子。',
          year: '唐代',
          picUrl: require('@images/collect_pic_4.png'),
          id: '21010302862117A000064'
        },
        // {
        //   name: '南宋缂丝绣线合璧册',
        //   desc: '开一朱克柔刻丝牡丹，明张习光对题。开二朱克柔刻丝山茶，文丛简对题。开三刻丝徽宗花卉，开四宋绣瑶台跨鹤，开五宋绣海棠双鸟，开六宋绣梅竹鹦鹉，鹦鹉羽毛有虫伤，上有明清收藏诸印，宝笈重编著录。',
        //   year: '南宋',
        //   picUrl: require('@images/collect_pic_5.png'),
        //   id: '21010302862118A000463'
        // },
        // {
        //   name: '竹雀双兔图轴',
        //   desc: '双鈎墨竹一丛，其中有长竹三竿，耸立其间，又有三只麻雀，分踞枝上。有的寻觅食物，有的静立下观，有的自理羽毛。丛竹之下，生长的三株野花，左为蒲公英，中为地黄，右为白头翁，显得鲜艳肥大，引入注意。花前两只灰兔，一只在吃草，一只在探望，神态逼真。',
        //   year: '辽代',
        //   picUrl: require('@images/collect_pic_6.png'),
        //   id: '21010302862117A000002'
        // },
        {
          name: '摹张萱虢国夫人游春图卷',
          desc: '设色临唐张萱画虢国夫人出游的情景。前後有女官、宫婢与保姆等八骑九人，均跨高头大马。整个画面，主题突出，春日正浓，景象豪华，形象逼真。用游丝描法细劲圆转，色彩浓润，确有“态浓意远淑且真，肌理细腻骨肉匀”的特点。',
          year: '北宋',
          picUrl: require('@images/collect_pic_7.png'),
          id: '21010302862117A000061'
        },
        {
          name: '摹王氏一门书翰卷',
          desc: '硬黄纸唐人双钩填墨本。计王羲之以下各帖为一卷。帖后小字“万岁通天二年……王方庆进”款一行。前后钤绍兴等诸收藏印。《石渠宝笈》著录。',
          year: '‘唐代',
          picUrl: require('@images/collect_pic_8.png'),
          id: '21010302862116A0001007'
        },
        // {
        //   name: '缂丝紫鸾鹊谱图轴',
        //   desc: '紫色地，五彩织鸟禽九种，衬以文藻。每谱回环累列。全轴分为两段，用錬丝织成。色彩鲜明，保存完好。',
        //   year: '北宋',
        //   picUrl: require('@images/collect_pic_9.png'),
        //   id: '21010302862118A000480'
        // },
        {
          name: '欧阳询书仲尼梦奠帖卷',
          desc: '此帖首尾九行，前后七十八字，章法疏朗，结字严整，用笔挺劲而不失丰腴。行笔顺应结字与章法，瘦劲猛锐而又自然流畅。点划凝重笃实，如“奠”、“满”、“祖”、“痛”诸字似裹锋落笔入纸，收笔回锋，乾净利落。',
          year: '唐代',
          picUrl: require('@images/collect_pic_10.png'),
          id: '21010302862117A001361'
        },
      ],
      dataList: [],
      dataMap:[
        {
          item: [
            {
              name: '白瓷盘口长颈注壶',
              desc: '盘口，折沿，竹节形长颈，管状直流，硕肩，下胫部内收，圈足外撇。肩饰一条凸起棱线。白瓷胎，胎质坚致细腻，外施白釉，莹润洁白，底足露白胎。',
              year: '辽代',
              picUrl: require('@images/collect_pic_11.png'),
              id: '21010302862103A000004'
            },
            {
              name: '彩绘双腹陶罐',
              desc: '唇口外敞、斜直肩，环形小腹、束腰、鼓腹，假圈足略外撇。器物整体造型优美端庄，各部比例协调，通体以黑彩和红彩搭配绘画几何纹和双连体回纹。',
              year: '新石器时代',
              picUrl: require('@images/collect_pic_12.png'),
              id: '21010302862104B0000450'
            },
            {
              name: '大晟南吕编钟',
              desc: '系青铜铸造,其形式古雅、铜质精纯。钟钮为双龙,钟面铸有蟠虺纹,形制属于椭圆筒式乐钟。钟一面铸有“大晟”一面铸有“南吕中声”篆文。钟唇下边刻有“上京都僧录官押”一行小字。',
              year: '北宋',
              picUrl: require('@images/collect_pic_13.png'),
              id: '21010302862105A000021'
            },
            {
              name: '绿釉贴团龙菊花纹双孔鸡冠壶',
              desc: '扁体高身，管状口，圆唇，马鞍状双孔系，红陶胎，椭圆形底微内敛，上白色化妆土，施绿釉，腹两侧周围饰贴皮条装饰，一侧饰印贴团龙纹，另一侧饰印贴菊花流云纹下划卷云纹，在后孔系上贴塑一人。',
              year: '辽代',
              picUrl: require('@images/collect_pic_14.png'),
              id: '21010302862104A000306'
            },
            {
              name: '鸭形玻璃器',
              desc: '质光亮，半透明，淡绿色，微见银绿色锈浸，体横长，呈鸭形，流如鸭嘴状，长颈鼓腹，细长尾，颈、腹部用玻璃条盘卷作出装饰；背有双翅，腹有双足，均系玻璃条粘成的，腹底粘一个平正的玻璃饼，此器重心在前，空体和满水时前倾，半水时才得平稳。',
              year: '北燕',
              picUrl: require('@images/collect_pic_15.png'),
              id: '21010302862127A0000103'
            },
          ]
        },
        {
          item: [
            {
              name: '青瓷飞鱼形水盂',
              desc: '器呈飞鱼形，鱼上颚翻卷，尾部高翘如船，穿出双翅，圈足平底。尾与翅周边饰圆形小水珠，全器如一条刚出水的游龙，披鳞展翼，腾空飞起，意态生动。瓷胎坚韧洁白，器表施青釉，晶莹透澈。',
              year: '辽代',
              picUrl: require('@images/collect_pic_16.png'),
              id: '21010302862103A0000140'
            },
            {
              name: '三彩印牡丹双蝶纹海棠盘',
              desc: '器呈八曲海棠花式，宽折沿，斜直壁，浅腹，平底。粉红色陶胎，胎质细腻坚致，挂白粉衣，外壁黄釉，盘内施三彩釉。折沿印卷草纹，内心印绿叶牡丹一朵，两侧衬以对飞的蝴蝶，以白釉为地。造型优美大方，纹饰富丽生动。',
              year: '辽代',
              picUrl: require('@images/collect_pic_17.png'),
              id: '21010302862103C000068'
            },
            {
              name: '“叠胜”琥珀小佩盒',
              desc: '琥珀雕刻，一盖一底，有子母扣可相扣合，盖底同式平面为两个叠形的菱形，刻楷书“叠胜”二字。周围加透雕花饰，出六珌耳，下垂绶结，胜为古代一种菱形花饰，此盒两胜相叠，故曰叠胜，造型别致。',
              year: '辽代',
              picUrl: require('@images/collect_pic_18.png'),
              id: '21010302862384A000017'
            },
            {
              name: '花树状金饰',
              desc: '此器基部长方形，透雕云纹，周边满布针孔，基部四角各一穿孔，大的有13长枝，3短枝，共16枝，每枝上缠有小环四、五个，并均系有桃形金叶数枚，枝叶繁茂如花树。小的有11分支，其中1枝已断，枝上有缠环和桃形金叶。',
              year: '三国-北朝',
              picUrl: require('@images/collect_pic_19.png'),
              id: '21010302862107B000096'
            },
            {
              name: '马蹄金',
              desc: '整体呈马蹄状，形象逼真，蹄内中空，蹄底内凹，有划痕。',
              year: '西汉',
              picUrl: require('@images/collect_pic_20.png'),
              id: '21010302862105C000152'
            },
          ]
        },
        {
          item: [
            {
              name: '状泉四十铜钱范',
              desc: '',
              year: '新莽',
              picUrl: require('@images/collect_pic_21.png'),
              id: '21010302862124A0000004'
            },
            {
              name: '白釉黑花葫芦瓶',
              desc: '器身为一葫芦形，龙柄，管状短流，塔式钮，底有一孔，上接管状柱，柱要与流平齐，流上骑一人，圈足，瓷胎，全器施乳白釉，上饰点状铁彩黑花，下腹部雕莲瓣纹。',
              year: '辽代',
              picUrl: require('@images/collect_pic_22.png'),
              id: '21010302862103A0000047'
            },
            {
              name: '九霄环佩琴',
              desc: '红漆面，七弦，十三徽，细蛇腹纹，在龙池上刻“九霄环佩”篆书四字。下刻“夏氏泰符子子孙孙永宝”篆书方印。池下刻“清和”篆书大方印。右侧刻隶书“响泉韵磬”四字及“乾隆御赏”小隶书两行。下刻“几暇临池”篆书方印清乾隆时做黑漆盒。盒盖刻有“宋制”隶书二字，其上刻“九霄环佩”四字，下刻“大清乾隆辛酉年制”。',
              year: '唐代',
              picUrl: require('@images/collect_pic_23.png'),
              id: '21010302862323B000007'
            },
            {
              name: '安国侯铜虎符',
              desc: '青铜铸造，卧虎形，尾上翘，后肢蜷屈，前肢伸屈，塌腰、抬首，内壁有木榫。虎身有“与安国侯为虎符第三”二行九字款',
              year: '战国',
              picUrl: require('@images/collect_pic_24.png'),
              id: '21010302862105A000015'
            },
            {
              name: '岁寒三友玻璃胎画珐琅葫芦式鼻烟壶',
              desc: '壶体呈葫芦形，乳白色的玻璃作胎，锦地绘以黄色珐琅彩，并彩绘岁寒三友：松（墨绿色）、竹（浅绿色）、梅（白色、粉色），壶口部及圈足各有一道蓝色弦纹，圈足底有“乾隆年制”款，绿料盖带牙匙，是典型的“古月轩”产品。',
              year: '清代',
              picUrl: require('@images/collect_pic_25.png'),
              id: '21010302862384A0000280'
            },
          ]
        },
      ],
      mapQuery: {
        currentPage: 1,
        size: 5,
        // totalPage: 0,
        totalPage: 3,
        total: 15
      },
    }
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: '/collect/detail',
        query: {id: item.id, pageType: '1'}
      })
    },
    initData() {
      this.$http
        .get(`../${process.env.BASE_URL}test/collect.json`, {
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            this.dataMap = data.dataMap
            this.getDataList()

            console.log(this.dataMap)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDataList() {
      let _index = this.mapQuery.currentPage - 1
      this.dataList = this.dataMap[_index].item
      // this.$http
      //   .get('/GemingWenwu/getGemingWenwuTuijian.do', {
      //     id: '6a7b657fe2624a709e90355ec42f3af6',
      //     // id: this.detailId,
      //     ...this.mapQuery,
      //   })
      //   .then(res => {
      //     this.listLoading = false
      //     if (res.success) {
      //       // this.totalCount = res.page.allRow
      //       this.dataList = res.data
      //       this.mapQuery.total = res.page.allRow
      //       this.mapQuery.totalPage = res.page.totalPage
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
    },
    initSwiper() {
      this.$nextTick(() => {
        let swiper = new Swiper(".page-collect-treasure .swiper-container-1", {
          // loop: true,
          // loopAdditionalSlides: 2,
          // autoplay: 5000,
          // slidesPerView: 1,
          // spaceBetween: 20,
          observer: true,
          observeParents: true,
          prevButton: '.page-collect-treasure .swiper-container-1 .swiper-button-prev',
          nextButton: '.page-collect-treasure .swiper-container-1 .swiper-button-next',
          // pagination: '.page-collect-treasure .swiper-container-1 .swiper-pagination-class',
          // paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
        })
      })
    },
    eventTabClick(val) {
      if(val === this.activeVal) return
      this.activeVal = val
      if(val === '1') {
        this.$router.push('/collect')
      } else if(val === '2') {
        this.$router.push('/collect/list')
      } else if(val === '3') {
        this.$router.push('/collect/digital-culture')
      } else if(val === '4') {
        this.$router.push('/collect/material')
      }
    },
    handlePrev() {
      if(this.mapQuery.currentPage > 1) {
        this.mapQuery.currentPage--
        this.getDataList()
      }
    },
    handleNext() {
      if(this.mapQuery.currentPage < this.mapQuery.totalPage) {
        this.mapQuery.currentPage++
        this.getDataList()
      }
    },
  },
  created() {
    // this.initData()
    this.getDataList()
    this.initSwiper()
  },
  // mounted() {
  //   this.initSwiper()
  // }
}
</script>

<style lang="scss" scoped>
.page-collect-treasure {
  .box {
    box-sizing: border-box;
    font-size: 24px;
    line-height: 36px;
    color: rgba($color: #000000, $alpha: 0.7);

    .btn-view {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 50%;
      bottom: -20px;
      transform: translateX(-50%);
      font-size: 16px;
      text-align: center;
      i {
        width: 32px;
        height: 32px;
        background: url(~@images/icon_right@2x.png) no-repeat center center;
        background-size: 100% 100%;
        transform: rotate(90deg);
      }
    }
    .item {
      h2 {
        color: #000000;
      }
    }
  }
  .box-1 {
    padding-top: 68px;
    // height: 1384px;
    // height: 800px;
    // background: url(~@images/collect-bg-1.jpg) no-repeat center center;
    // background-size: 100% 100%;

    .list {
      // width: 1200px;
      width: $minWidth;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      // color: #000;
      .item:nth-child(1) {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #5D4339;
        h2 {
          flex: 1;
          // width: 153px;
          text-align: right;
          font-size: 48px;
          color: #5D4339;
        }
        .pic-box {
          position: relative;
          margin: 0 44px;
          img {
            // width: 477px;
            // height: 668px;
            width: 250px;
            height: 368px;
          }

          .btn-view {}
        }
        .desc {
          flex: 1;
          // width: 210px;
        }
      }
      .item:nth-child(2),
      .item:nth-child(3) {
        margin-top: 60px;
        padding: 20px;
        width: 206px;
        height: 400;
        // width: 368px;
        // height: 584px;
        box-sizing: border-box;
        background: rgba($color: #F6F6F6, $alpha: 1);
        .pic-box {
          margin-bottom: 15px;
          // height: 120px;
          display: flex;
          align-items: center;
          img {
            width: 155px;
            height: 226px;
            // max-width: 100%;
            // max-height: 100%;
          }
        }
        .year {
          font-size: 18px;
          margin-top: 10px;
        }
      }
      .item:nth-child(3) {
        margin-left: 40px;
      }
    }
  }

  .box-3 {
    position: relative;
    // height: 800px;
    // background: url(~@images/collect-bg-3.jpg) no-repeat center center;
    // background-size: 100% 100%;

    .list {
      position: relative;
      // top: -58px;
      // width: $minWidth;
      margin: 30px auto 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .item {
        margin: 0 15px 30px;
        padding: 20px;
        width: 206px;
        height: 400px;
        box-sizing: border-box;
        background: rgba($color: #f6f6f6, $alpha: 1);
        .pic-box {
          margin-bottom: 15px;
          // height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 155px;
            height: 226px;
            // max-width: 100%;
            // max-height: 100%;
          }
        }
        .info {
          height: 120px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .year {
          font-size: 18px;
          margin-top: 15px;
        }
      }
      // .item:last-child {
      //   .pic-box {
      //     justify-content: initial;
      //     img {
      //       width: 539px;
      //       max-width: initial;
      //     }
      //   }
      // }
    }
  }

  .box-2 {
    position: relative;
    // height: 856px;
    // background: url(~@images/collect-bg-2.jpg) no-repeat center center;
    // background-size: 100% 100%;
    font-size: 26px;
    color: #5D4339;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;


    h2 {
      padding: 80px 0 36px;
      font-size: 48px;
    }
    .desc {
      width: 659px;
      height: 72px;
      margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .pic-box {
      margin-top: 30px;
      img {
        width: 100%;
        height: 187px;
      }

      .btn-view {
        bottom: -70px;
      }
    }
  }
}

.swiper-container-1{
  // width: 100%;
  // width: 1699px;
  width: $minWidth;
  padding-bottom: 70px;
  margin: 0 auto;
  // .img-title {
  //   width: 422px;
  //   height: 145px;
  //   margin: 50px 0 36px;
  // }
  .btn {
    width: 144px;
    height: 24px;
    margin: 40px auto 0;
    text-align: center;
    cursor: pointer;
    .more {
      width: 100%;
      height: 100%;
      display: inline-block;
      // background: url(../../assets/images/home/btn-bg.png) no-repeat center;
      background-size: 100% 100%;
      font-size: 16px;
      font-weight: bold;
      color: #7f3222;
      line-height: 24px;
    }
  }

  /*先去掉默认样式*/
  .swiper-button-prev:after {
    display: none;
  }
  .swiper-button-next:after {
    display: none;
  }
  /*再自定义样式*/
  .swiper-button-prev {
    width: 56px;
    height: 56px;
    background: url('~@images/icon_left@2x.png') no-repeat;
    background-size: 100% 100%;
    left: 0px;
    top: 68%;
  }
  .swiper-button-next {
    right: 0px;
    top: 68%;
    width: 56px;
    height: 56px;
    background: url('~@images/icon_right@2x.png') no-repeat;
    background-size: 100% 100%;
  }
}

.pages {
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  .pages-count {
    font-size: 14px;
    // font-weight: bold;
    color: #292423;
    line-height: 36px;
    // span {
    //   font-size: 36px;
    // }
  }
  .pages-r {
    display: flex;
    // background: #FDFBEC;
    .btn {
      // display: inline-block;
      display: flex;
      align-items: center;
      justify-content: center;
      // width: 64px;
      // height: 36px;
      // background:rgba(212,172,140,1);
      color: #292423;
      cursor: pointer;
      width: 73px;
      height: 73px;
      
      &.btn-prev {
        position: absolute;
        left: 40px;
        top: 74%;
        transform: translateY(-50%);
        background: url(~@images/btn-prev.png) no-repeat center center;
        background-size: 100% 100%;
      }
      &.btn-next {
        position: absolute;
        right: 40px;
        top: 74%;
        transform: translateY(-50%);
        background: url(~@images/btn-next.png) no-repeat center center;
        background-size: 100% 100%;
      }

      &.disabled {
        // color: #bfbcbb;
        &.btn-prev {
          opacity: 0.35;
        }
        &.btn-next {
          opacity: 0.35;
        }
      }
      &.border {
        // border-right: solid 1px $border;
      }
      .icon-triangle-prev {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-right: 6px solid #fff;
        border-bottom: 5px solid transparent;
      }
      .icon-triangle-next {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-left: 6px solid #fff;
        border-bottom: 5px solid transparent;
      }
    }
  }
}
</style>


